// @flow

export function Stringellipsis(str: string, max: number): string {
  if (str.length > max) {
    str = str.substring(0, max) + "...";
  }
  return str;
}

export function propComparator(
  prop: *,
  isLower?: boolean = false,
  secondProp?: string | null = null,
  thirdProp?: string | null = null,
  isDate?: boolean = false,
  DoubleField?: string | null = null
): * {
  return function(a: *, b: *): number {
    let aProp;
    let bProp;
    let a2Prop;
    let b2Prop;
    if (thirdProp) {
      if (isDate) {
        aProp = a[prop][secondProp][thirdProp]
          ? new Date(a[prop][secondProp][thirdProp]).getTime()
          : 0;
        bProp = b[prop][secondProp][thirdProp]
          ? new Date(b[prop][secondProp][thirdProp]).getTime()
          : 0;
      } else if (isLower) {
        aProp = a[prop][secondProp][thirdProp].toLowerCase();
        bProp = b[prop][secondProp][thirdProp].toLowerCase();
      } else {
        aProp = a[prop][secondProp][thirdProp];
        bProp = b[prop][secondProp][thirdProp];
      }

      if (DoubleField) {
        a2Prop = a[prop][secondProp][DoubleField];
        b2Prop = b[prop][secondProp][DoubleField];
      }
    } else if (secondProp) {
      if (isDate) {
        aProp = a[prop][secondProp]
          ? new Date(a[prop][secondProp]).getTime()
          : 0;
        bProp = b[prop][secondProp]
          ? new Date(b[prop][secondProp]).getTime()
          : 0;
      } else if (isLower) {
        aProp = a[prop][secondProp].toLowerCase();
        bProp = b[prop][secondProp].toLowerCase();
      } else {
        aProp = a[prop][secondProp];
        bProp = b[prop][secondProp];
      }

      if (DoubleField) {
        a2Prop = a[prop][DoubleField];
        b2Prop = b[prop][DoubleField];
      }
    } else {
      if (isDate) {
        aProp = a[prop] ? new Date(a[prop]).getTime() : 0;
        bProp = b[prop] ? new Date(b[prop]).getTime() : 0;
      } else if (isLower) {
        aProp = a[prop].toLowerCase();
        bProp = b[prop].toLowerCase();
      } else {
        aProp = a[prop];
        bProp = b[prop];
      }

      if (DoubleField) {
        a2Prop = a[DoubleField];
        b2Prop = b[DoubleField];
      }
    }

    if (a2Prop && b2Prop) {
      return doublePropCompare(aProp, bProp, a2Prop, b2Prop);
    } else {
      return propCompare(aProp, bProp);
    }
  };
}

export function propCompare(aProp: *, bProp: *): number {
  if (aProp > bProp) {
    return 1;
  } else if (aProp < bProp) {
    return -1;
  } else {
    return 0;
  }
}

export function doublePropCompare(
  aProp: *,
  bProp: *,
  a2Prop: *,
  b2Props: *
): number {
  if (aProp > bProp) {
    return 1;
  } else if (aProp === bProp) {
    if (a2Prop > b2Props) {
      return 1;
    } else if (a2Prop === b2Props) {
      return 0;
    } else {
      return -1;
    }
  } else if (aProp < bProp) {
    return -1;
  } else {
    return 0;
  }
}
